import NProgress from 'nprogress';
import { Suspense, useEffect } from 'react';
import Routes from 'routes';
import { useLocation } from 'react-router-dom';
import { Flip, ToastContainer } from 'react-toastify';
import { IToastType } from 'components/Toast';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './styles/custom-style.css';
import AxiosInterceptor from 'interceptors/axios.interceptor';
import * as Sentry from '@sentry/react';
import Clarity from '@microsoft/clarity';

NProgress.configure({
  trickle: true,
  trickleSpeed: 100000
});

interface IContextClass extends IToastType {
  [key: string]: string;
}
const contextClass: IContextClass = {
  success: 'bg-success-100 border-success-500',
  error: 'bg-error-100 border-error-400',
  info: 'bg-info-100 border-info-500',
  warning: 'bg-warning-200 border-warning-500'
};

const isWindowsOs = () => {
  let OSName = 'Unknown OS';
  if (window.navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows';
  return OSName === 'Windows';
};

if (isWindowsOs()) {
  import('./styles/scrollbars.css').then(() => {});
}

if (import.meta.env.VITE_NODE_ENV === 'production') {
  Clarity.init('tlet56y4h2');
  Sentry.init({
    dsn: 'https://794ff40506f43afb1270bc0072d1c19c@o4506423006593024.ingest.us.sentry.io/4507350016065536',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

function App() {
  const location = useLocation();

  useEffect(() => {
    NProgress.start();
    NProgress.done();
  }, [location]);

  return (
    <Suspense>
      <AxiosInterceptor>
        <Routes />
      </AxiosInterceptor>
      <ToastContainer
        position="top-right"
        transition={Flip}
        icon={false}
        closeButton={false}
        toastClassName={({ type }: any) =>
          `${contextClass[type || 'default']} shadow-lg  border rounded-lg`
        }
        hideProgressBar
      />
    </Suspense>
  );
}
export default App;
